import {
    Flex,
    Td,
    Text,
    Tr,
    useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import {flexRender} from "@tanstack/react-table";

function DashboardTableRow(props) {
  const { row } = props;
  const textColor = useColorModeValue("gray.700", "white");
  let cells = row.getVisibleCells();


  return (
      <Tr>
          <Td key={cells[0].id} pl="0px">
              <Flex alignItems="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
                  <Text pl={'25px'} fontSize="sm" color={textColor} fontWeight="bold" minWidth="100%">
                      {flexRender(
                          cells[0].column.columnDef.cell,
                          cells[0].getContext()
                      )} ({(cells[0].getContext().row.original.currency)})
                  </Text>
              </Flex>
          </Td>
          <Td  key={cells[1].id}>
              <Text fontSize="sm" color={textColor} fontWeight="bold" pb=".5rem">
                  {flexRender(
                      cells[1].column.columnDef.cell,
                      cells[1].getContext()
                  )}
              </Text>
          </Td>
          <Td key={cells[2].id}>
              <Text fontSize="sm" color={textColor} fontWeight="bold" pb=".5rem">
                  {flexRender(
                      cells[2].column.columnDef.cell,
                      cells[2].getContext()
                  )}
              </Text>
          </Td>
      </Tr>
  );
}

export default DashboardTableRow;
